import { render, staticRenderFns } from "./ShippedArticles.vue?vue&type=template&id=b92c3b46&scoped=true"
import script from "./ShippedArticles.vue?vue&type=script&lang=js"
export * from "./ShippedArticles.vue?vue&type=script&lang=js"
import style0 from "./ShippedArticles.vue?vue&type=style&index=0&id=b92c3b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92c3b46",
  null
  
)

export default component.exports